import { ProcessedMarketData } from '@velocity-exchange/common';

// A publisher can step back from the MM oracle to an older exchange oracle,
// so after this long accept the older oracle rather than freeze the book.
const MAX_HOLD_MS = 1000;

/**
 * Publishers can send the same slot priced off different oracle reads.
 * Returns a filter that drops books priced with an older oracle than the last one shown.
 */
export function createOracleSlotGuard(now: () => number = Date.now) {
	let lastOracleSlot = 0;
	let lastAcceptedAt = 0;

	return ({
		deserializedData: { mmOracleData, oracleData },
	}: ProcessedMarketData) => {
		const oracleSlot = (mmOracleData?.slot ?? oracleData.slot)?.toNumber() ?? 0;
		const time = now();
		if (oracleSlot < lastOracleSlot && time - lastAcceptedAt <= MAX_HOLD_MS) {
			return false;
		}
		lastOracleSlot = oracleSlot;
		lastAcceptedAt = time;
		return true;
	};
}
